import { render, staticRenderFns } from "./DetmirElementConfigurableScaleMinTableColumn.vue?vue&type=template&id=b182d3c2"
import script from "./DetmirElementConfigurableScaleMinTableColumn.vue?vue&type=script&lang=js"
export * from "./DetmirElementConfigurableScaleMinTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports